export const LINK_REL_DEFAULT_LIST = ['noreferrer', 'noopener'];
